/**
 * @generated SignedSource<<17f6c1946162ddba4126d43788ab27a8>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type InternBrandStyleComponentMapping_brand$data = {
  readonly appConfig: {
    readonly htmlCustomAttributes: ReadonlyArray<{
      readonly attributeKey: string;
      readonly attributeValue: string;
      readonly querySelector: string;
    }> | null;
    readonly id: string;
  };
  readonly id: string;
  readonly internStyle: {
    readonly componentMappings: ReadonlyArray<{
      readonly selector: string;
      readonly style: string;
    }>;
  } | null;
  readonly " $fragmentType": "InternBrandStyleComponentMapping_brand";
};
export type InternBrandStyleComponentMapping_brand$key = {
  readonly " $data"?: InternBrandStyleComponentMapping_brand$data;
  readonly " $fragmentSpreads": FragmentRefs<"InternBrandStyleComponentMapping_brand">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "InternBrandStyleComponentMapping_brand",
  "selections": [
    (v0/*: any*/),
    {
      "alias": null,
      "args": null,
      "concreteType": "InternBrandStyle",
      "kind": "LinkedField",
      "name": "internStyle",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "InternBrandStyleComponentMapping",
          "kind": "LinkedField",
          "name": "componentMappings",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "selector",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "style",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "BrandAppConfigType",
      "kind": "LinkedField",
      "name": "appConfig",
      "plural": false,
      "selections": [
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "HTMLCustomAttribute",
          "kind": "LinkedField",
          "name": "htmlCustomAttributes",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "querySelector",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attributeKey",
              "storageKey": null
            },
            {
              "alias": null,
              "args": null,
              "kind": "ScalarField",
              "name": "attributeValue",
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": null
    }
  ],
  "type": "BrandType",
  "abstractKey": null
};
})();

(node as any).hash = "93a8df04732f21eb9e9fba3af053fd73";

export default node;
